import { z } from 'zod'

export const requestPasswordResetSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'auth-common:form.errors.required')
    .email({ message: 'auth-common:form.errors.email' }),
})

export type RequestPasswordResetFormValues = z.infer<
  typeof requestPasswordResetSchema
>
